// Copyright (c) StrangeBee 2024

import { PageController, PageInput, PageOutput } from 'thehive-sdk';

export interface PageEventList {
    onCreate: (page: PageInput) => Promise<void>;
    onEdit: (page: Partial<PageInput>, pageId: string) => Promise<void>;
    onDelete: (pageId: string) => Promise<void>;
}

interface PageEventListParams {
    locale: (label: string) => string;
    controller: PageController;
    onSuccess: (count?: boolean, message?: string) => void;
    onError: (label?: string) => void;
}

export const computeEventList = ({ controller, locale, onError, onSuccess }: PageEventListParams): PageEventList => ({
    onCreate: (page: PageInput) =>
        controller
            .create<PageInput, PageOutput>(page)
            .then(() => onSuccess(true, locale('notification.page.create')))
            .catch(onError),
    onEdit: (page: Partial<PageInput>, pageId: string): Promise<void> =>
        controller
            .edit(page, pageId)
            .then(() => onSuccess(false, locale('notification.page.edit')))
            .catch(onError),
    onDelete: (pageId: string): Promise<void> =>
        controller
            .delete(pageId)
            .then(() => onSuccess(false, locale('notification.page.delete')))
            .catch(onError),
});
